import { ILease } from "./PA.UtilsIF";
import * as _ from "lodash";
import { LeaseServer } from "./LeaseServer";

export class LeaseRegistry {
    private static iLeases: ILease[] = [];
    private static _leaseServer: LeaseServer = undefined;

    static readonly Lease_Class_All = "All";
    static readonly Lease_Subject_MasterDataSet = "MasterDataSet";
    static readonly Lease_Subject_SalesOrg = "SalesOrg";

    static readonly Lease_Type_ConditionContext = "ConditionContext";
    static readonly Lease_Subject_Customer = "Customer";
    static readonly Lease_Subject_Customer_Hierarchy = "CustomerHierarchy";
    static readonly Lease_Subject_FundType = "FundType";
    static readonly Lease_Subject_ConditionType = "ConditionType";

    static readonly Lease_Type_ProductGroup = "ProductGroup";
    static readonly Lease_Type_Product = "Product";
    static readonly Lease_Subject_ProductGroup = "ProductGroup";
    static readonly Lease_Subject_Product = "Product";

    static readonly Lease_Type_Customer_Hierarchy = "CustomerHierarchyContext";

    static readonly Lease_Type_Product_Hierarchy = "ProductHierarchyContext";
    static readonly Lease_Subject_Product_Hierarchy = "ProductHierarchy";

    static readonly Lease_Type_Period_Hierarchy = "PeriodHierarchyContext";
    static readonly Lease_Subject_Period_Hierarchy = "PeriodHierary";

    static readonly Lease_Type_Product_BOM = "ProductBOM";
    static readonly Lease_Type_PeriodType = "PeriodType";
    static readonly Lease_Type_Period = "Period";
    static readonly Lease_Type_SnapshotM = "SnapshotM";
    static readonly Lease_Type_GLRule = "GLRule";
    static readonly Lease_Type_Metrics = "Metrics";
    static readonly Lease_Type_SubjectArea = "SubjectArea";
    static readonly Lease_Type_PricingEngine = "PricingEngine";
    static readonly Lease_Type_CubeSource = "CubeSource";
    static readonly Lease_Type_CubeSource_Profile = "CubeSourceProfile";
    static readonly Lease_Type_DataObject = "DataObject";

    static readonly Lease_Type_DimensionHierarchy = "HANADimHier";
    static readonly Lease_Subject_DimensionHierarchy = "HANADimHier";

    static readonly Lease_Type_ReportingDimensionHierarchy = "ReportingDimHierarchy";

    static readonly Lease_Type_Approval = "Approval";

    static readonly Lease_Type_MetricView = "MetricView";

    static readonly Lease_Subject_Model = "Model";
    static readonly Lease_Subject_Model_Predictor = "ModelPredictor";
    static readonly Lease_Subject_Model_Coefficient = "ModelCoefficient";
    static readonly Lease_Subject_ModelingSession = "ModelingSession";
    static readonly Lease_Subject_CoefficientSet = "CoefficientSet";
    static readonly Lease_Subject_Simulation = "Simulation";

    static readonly Lease_Subject_MetaType = "WbMeta";
    static readonly Lease_Subject_StatusType = "WbStatus";

    private static get LeaseServer(): LeaseServer {
        LeaseRegistry.checkLeaseServer();
        return LeaseRegistry._leaseServer;
    }

    private static checkLeaseServer(): void {
        if (_.isUndefined(LeaseRegistry._leaseServer)) {
            LeaseRegistry._leaseServer = new LeaseServer();
        }
    }

    static registerILease(lease: ILease) {
        LeaseRegistry.checkLeaseServer();
        LeaseRegistry.iLeases.push(lease);
    }

    static generateLeaseInvalidationByClassList(sClasses: string[]) {
        LeaseRegistry.checkLeaseServer();
        //force lease invalidation on local server and broadcast invalidation to other servers
        _.forEach(sClasses, (aClass) => {
            LeaseRegistry.invalidateLeasesByClass(aClass);
        });

        LeaseRegistry.LeaseServer.broadcastResetLeaseClass(sClasses).catch((err) => {
            console.error("Error broadcasting lease invalidation: ", err);
        });
    }

    static generateLeaseInvalidationByClass(sClass: string) {
        LeaseRegistry.checkLeaseServer();
        //force lease invalidation on local server and broadcast invalidation to other servers
        LeaseRegistry.invalidateLeasesByClass(sClass);
        LeaseRegistry.LeaseServer.broadcastResetLeaseClass(sClass).catch((err) => {
            console.error("Error broadcasting lease invalidation: ", err);
        });
    }

    static invalidateLeasesByClass(aClass: string) {
        //force lease invalidation on local server
        _.forEach(LeaseRegistry.iLeases, (aLease) => {
            if (aLease.hasClass(aClass)) {
                aLease.forceExpire();
            }
        });
    }

    static invalidateLeasesByClassList(sClasses: string[]) {
        //force lease invalidation on local server
        _.forEach(sClasses, (aClass) => {
            LeaseRegistry.invalidateLeasesByClass(aClass);
        });
    }

    static getLeaseClass(className: string, wbID?: number | string): string {
        return _.isUndefined(wbID) ? className : className + "-" + wbID;
    }

    static invalidateAllLeases() {
        LeaseRegistry.invalidateLeasesByClass(LeaseRegistry.Lease_Class_All);
    }

    static async generateInvalidateAllLeases(): Promise<void> {
        LeaseRegistry.checkLeaseServer();
        LeaseRegistry.invalidateAllLeases();
        await LeaseRegistry.LeaseServer.broadcastResetLeaseClass(LeaseRegistry.Lease_Class_All);
        console.log(`${new Date().toUTCString()} - Invalidated all leases`);
    }
}
